// extracted by mini-css-extract-plugin
module.exports = {"container":"_3VpaZ","content":"_2udsm","section":"_3SBk8","sectionTitle":"ZRhZV","sectionDescription":"_2URmv","separator":"_20M_d"};